import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Container, Dropdown, Row } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import Breadcrumb from '../../../Common/BreadCrumb';
import DeleteModal from '../../../Common/modals/DeleteModal';

import { useOrderCancelDeleteMutation, useOrderInvoiceMutation, useOrderStatusMutation, useOrderTrackingDeleteMutation, useOrderTrackingInfoDataQuery } from '../../../Redux/OrderSlice';
import OrderStatus from './OrderStatus';
import { toast } from 'react-toastify';
import Orderinvoicemodal from './OrderInvoice/Orderinvoicemodal';

const Tracking = ['Order Process', 'Packed', 'Order Shipped', 'Out for Delivery', 'Delivered'];
const OrdersOverview = () => {
    document.title = "Order Overview | Toner eCommerce + Admin React Template";
    // const [OrderInfoDataFunc, { data: orderViewData }] = useOrderInfoDataMutation();


    const { id } = useParams()

    const { data: trackingData } = useOrderTrackingInfoDataQuery(id, { skip: !id })

    const [OrderStatusFunc, { isSuccess: trackSuccess }] = useOrderStatusMutation();
    const [OrderTrackingDeleteFunc, { data: deleteData, error: deleteErr, isLoading: deleteLoading, isSuccess: DeleteSuccess }] =
        useOrderTrackingDeleteMutation();
    const [OrderCancelFunc, { data: CancelOrderData, error: cancelorderErr, isLoading: cancelorderLoading, isSuccess: cancelorderSuccess }] =
        useOrderCancelDeleteMutation();
    const [invoiceinfo,
        {
            data: invoiceinfoData,
            error: invoiceinfoErr,
            isError: invoiceinfoIsErr,
            isLoading: invoiceinfoLoading,
            isSuccess: invoiceinfoSuccess,
        },
    ] = useOrderInvoiceMutation(undefined);
    const [showModal, setShowModal] = useState(false);
    const [DeleteID, setDeleteID] = useState();
    const [orderUniqueId, setOrderUniqueId] = useState();
    const [ordertracking, setOrderTracking] = useState();
    const [OrderActivities, setOrderActivities] = useState();
    const [orderinformation, setOrderInformation] = useState({});
    const [orderStatus, setOrderStatus] = useState();
    const [orderStatusID, setOrderStatusID] = useState();
    const [orderStatusDetails, setOrderStatusDetails] = useState(undefined);
    const [trackLength, setTrackLength] = useState(0);
    const [productID, setProductID] = useState(0);
    const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);


    const getImageURL = (ids, array) => {
        let info
        array?.map((val, id) => {
            val?.image?.map((item, index) => {
                if (item?.productColourId === ids) {
                    info = item?.preview
                }
            })
        })
        return info

    }

    useEffect(() => {
        if (id && trackingData?.response?.orders?.id) {
            // OrderInfoDataFunc(id).then(res => {
            const getOrderinfo = trackingData?.response;
            setOrderInformation(getOrderinfo?.orders);
            setOrderUniqueId(getOrderinfo?.orderUniqueId);

            if (getOrderinfo?.ActivityLog?.length > 0) {
                setOrderStatus(getOrderinfo.ActivityLog)
            }

            if (orderStatusDetails) {
                OrderStatusDetailsFunc(productID, orderStatusDetails, getOrderinfo.ActivityLog)
            }


        }
    }, [id, trackingData])


    useEffect(() => {
        if (ordertracking && id) {
            OrderStatusFunc({ orderId: id, trackingStatus: ordertracking, trackingTimeChange: new Date() })
        }
    }, [ordertracking, id])

    useEffect(() => {
        if (trackSuccess == true) {
            toast.success("Tracking Status Updated Please Click The Checking Status ");
        }
        else if (DeleteSuccess == true) {
            toast.success("Tracking Status Remove Successfully Please Click The Checking Status")
        }
    }, [DeleteSuccess, trackSuccess])

    // useEffect(() => {
    //     if (orderinformation) {
    //         let grssamount = 0
    //         let MRPdiscount = 0
    //         let CouponDiscount = 0
    //         let taxamount = 0
    //         let cgstamount = 0
    //         let sgsttamount = 0
    //         let totalamount = 0

    //         orderinformation?.Cart?.CartItems?.map((data, item) => {
    //             console.log('data', data)
    //             grssamount += Number(data?.MRP * data?.quantity)
    //             MRPdiscount += Number(data?.discount * data?.quantity)
    //             taxamount += Number(data?.taxAbleAmount * data?.quantity)
    //             cgstamount += Number(data?.CGST * data?.quantity)
    //             sgsttamount += Number(data?.SGST * data?.quantity)
    //         })

    //         setPrice({
    //             grAmt: grssamount,
    //             MRPDis: MRPdiscount,
    //             taxAmt: taxamount,
    //             cgst: cgstamount,
    //             sgst: sgsttamount,
    //             CouponDiscount: responseinvoice?.discount ? responseinvoice?.discount : 0,
    //             totalamount: grssamount - MRPdiscount - responseinvoice?.discount + taxamount + cgstamount + sgsttamount
    //         })
    //     }
    // }, [orderinformation])
    const OrderStatusDetailsFunc = (ObjectID, Productname, updateStaus) => {
        console.log('Productname', ObjectID, Productname)
        const clickedItemId = ObjectID;
        setProductID(ObjectID);
        let isIdIncluded;
        if (updateStaus) {
            isIdIncluded = updateStaus.some(obj => Object.keys(obj)[0] === clickedItemId);

        } else {
            isIdIncluded = orderStatus.some(obj => Object.keys(obj)[0] === clickedItemId);

        }
        if (isIdIncluded) {
            const matchingObject = orderStatus.find(obj => Object.keys(obj)[0] === clickedItemId);
            const arrayInsideObject = Object.values(matchingObject)[0];
            setOrderStatusID(arrayInsideObject);
            setOrderActivities(arrayInsideObject);
            setTrackLength(arrayInsideObject?.length);
            setOrderStatusDetails(Productname);
            console.log('arrayInsideObject?.length', arrayInsideObject?.length)
        } else {
            console.log('no');
        }
    }

    const RemoveStatusFunc = (id) => {
        OrderTrackingDeleteFunc(id)
        setShowModal(false)
    }

    const formatOrderActivities = OrderActivities?.filter(it => it.trackingStatus != 'Cancelled');
    const isCancelled = OrderActivities?.find(it => it.trackingStatus == "Cancelled");
    const cancelledOrders = OrderActivities?.filter(item => item.trackingStatus === "Cancelled");



    // Function to format address information
    const formatAddress = (address) => {
        const addressLine1 = address?.addressLine1 || "Address1";
        const addressLine2 = address?.addressLine2 || "Address2";
        const addressType = address?.addressType || "Address Type";
        const city = address?.city || "City";
        const state = address?.state || "State";
        const pincode = address?.pincode || "Pin Code";
        const country = address?.country || "Country";
        const phone = address?.phone || "Phone number";

        const addressInfo = `${addressLine1}, ${addressLine2}, ${addressType}`;
        const addressBase = `${city}, ${state}`;
        const addressCommon = `${pincode}, ${country}`;
        const phoneNumber = `${phone}`;

        return { addressInfo, addressBase, addressCommon, phoneNumber };
    };

    // Shipping Address
    const shippingInfo = formatAddress(orderinformation?.shippingAddress);
    const ShippingAddressInfo = shippingInfo.addressInfo;
    const ShippingAddressBase = shippingInfo.addressBase;
    const ShippingAddressCommon = shippingInfo.addressCommon;
    const ShippingPhone = shippingInfo.phoneNumber;

    // Billing Address
    const billingInfo = formatAddress(orderinformation?.billingAddress);
    const BillingAddressInfo = billingInfo.addressInfo;
    const BillingAddressBase = billingInfo.addressBase;
    const BillingAddressCommon = billingInfo.addressCommon;
    const BillingPhone = billingInfo.phoneNumber;

    const handleOptionClick = (value, index) => {
        setOrderTracking(value);
        setTrackLength(index);
    };

    const isDisabled = (value, index) => {
        const disabledValues = {
            0: [1, 2, 3, 4, 5],
            1: [2, 3, 4, 5],
            2: [1, 4, 3, 5],
            3: [1, 2, 4, 5],
            4: [1, 2, 3, 5],
        };
        return disabledValues[index].includes(trackLength);
    };



    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumb title="Overview" pageTitle="Orders" />
                    <Row className="mb-4 align-items-center">
                        <Col>
                            <h6 className="fs-18 mb-0">Order ID: #{orderinformation?.orderUniqueId}</h6>
                        </Col>
                        <Col className="col text-end">
                            <Button
                                variant='secondary'

                                onClick={() => {
                                    invoiceinfo(orderinformation.id).then((res) => {
                                        if (res) {
                                            setInvoiceModalOpen(true)
                                        }
                                    })
                                }
                                }
                            > <i className="ph-download-simple me-1 align-middle"></i>
                                {' '}
                                Invoice
                            </Button>
                        </Col>

                    </Row>
                    <Row className="mb-4 align-items-center">

                        <OrderStatus orderStatusDetails={orderStatusDetails} />
                    </Row>

                    <Row>

                        <Col xxl={3} lg={6}>
                            <div className="card bg-success bg-opacity-10 border-0">
                                <div className="card-body">
                                    <div className="d-flex gap-3">
                                        <div className="flex-grow-1">
                                            <h6 className="fs-18 mb-3">Customer Info</h6>
                                            <p className="mb-0 fw-medium"> {orderinformation.shippingAddressInfo ? orderinformation.shippingAddressInfo.name : orderinformation?.User?.firstName !== null ? orderinformation?.User?.firstName + " " + orderinformation?.User?.lastName : "FirstName LastName"}</p>
                                            <p className="mb-1">{orderinformation.shippingAddressInfo ? orderinformation.shippingAddressInfo.email : orderinformation?.User?.email ? orderinformation?.User?.email : null}</p>
                                            <p className="mb-0">{orderinformation.shippingAddressInfo ? orderinformation.shippingAddressInfo.phone : orderinformation?.User?.phone ? orderinformation?.User?.countryCode + orderinformation?.User?.phone : 'phone number'}</p>
                                        </div>
                                        <div className="avatar-sm flex-shrink-0">
                                            <div className="avatar-title bg-success-subtle text-success rounded fs-3">
                                                <i className="ph-user-circle"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xxl={3} lg={6}>
                            <div className="card bg-primary bg-opacity-10 border-0">
                                <div className="card-body">
                                    <div className="d-flex gap-3">
                                        <div className="flex-grow-1">
                                            <h6 className="fs-18 mb-3">Shipping Address</h6>
                                            <p className="mb-0">{orderinformation.shippingAddressInfo ? orderinformation.shippingAddressInfo.addressLine1 + "," + orderinformation.shippingAddressInfo.addressLine2 + "," + orderinformation?.shippingAddress?.addressType : orderinformation?.shippingAddress?.addressLine1 + "," + orderinformation?.shippingAddress?.addressLine2 + "," + orderinformation?.shippingAddress?.addressType}</p>
                                            <p className="mb-0"> {orderinformation.shippingAddressInfo ? orderinformation.shippingAddressInfo.city + "," : orderinformation?.shippingAddress?.city + ","}</p>
                                            <p className="mb-0"> {orderinformation.shippingAddressInfo ? orderinformation.shippingAddressInfo.state + "," : orderinformation?.shippingAddress?.state + ","}</p>
                                            <p className="mb-1">{orderinformation.shippingAddressInfo ? orderinformation.shippingAddressInfo.pincode + "," : orderinformation?.shippingAddress?.pincode + ","}</p>
                                            <p className="mb-0">{orderinformation.shippingAddressInfo ? orderinformation.shippingAddressInfo.country + "," : orderinformation?.shippingAddress?.country}</p>
                                        </div>
                                        <div className="avatar-sm flex-shrink-0">
                                            <div className="avatar-title bg-primary-subtle text-primary rounded fs-3">
                                                <i className="ph-map-pin"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xxl={3} lg={6}>
                            <div className="card bg-info bg-opacity-10 border-0">
                                <div className="card-body">
                                    <div className="d-flex gap-3">
                                        <div className="flex-grow-1">
                                            <h6 className="fs-18 mb-3"> Billing Address </h6>
                                            <p className="mb-0">{orderinformation?.billingAddressInfo ? orderinformation?.billingAddressInfo.addressLine1 + "," + orderinformation?.billingAddressInfo.addressLine2 + "," + orderinformation?.shippingAddress?.addressType : orderinformation?.shippingAddress?.addressLine1 + "," + orderinformation?.shippingAddress?.addressLine2 + "," + orderinformation?.shippingAddress?.addressType}</p>
                                            <p className="mb-0"> {orderinformation?.billingAddressInfo ? orderinformation?.billingAddressInfo.city + "," : orderinformation?.shippingAddress?.city + ","}</p>
                                            <p className="mb-0"> {orderinformation?.billingAddressInfo ? orderinformation?.billingAddressInfo.state + "," : orderinformation?.shippingAddress?.state + ","}</p>
                                            <p className="mb-1">{orderinformation?.billingAddressInfo ? orderinformation?.billingAddressInfo.pincode + "," : orderinformation?.shippingAddress?.pincode + ","}</p>
                                            <p className="mb-0">{orderinformation?.billingAddressInfo ? orderinformation?.billingAddressInfo.country + "," : orderinformation?.shippingAddress?.country}</p>
                                        </div>
                                        <div className="avatar-sm flex-shrink-0">
                                            <div className="avatar-title bg-info-subtle text-info rounded fs-3">
                                                <i className="ph-file-text"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xxl={3} lg={6}>
                            <div className="card card-primary overflow-hidden">
                                <div className="position-absolute end-0 start-0 bottom-0 z-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1"
                                        // xmlns:xlink="http://www.w3.org/1999/xlink"
                                        width="400" height="250" preserveAspectRatio="none" viewBox="0 0 400 250">
                                        <g mask="url(&quot;#SvgjsMask1551&quot;)" fill="none">
                                            <path d="M306 65L446 -75" strokeWidth="8" stroke="url(#SvgjsLinearGradient1558)" strokeLinecap="round" className="BottomLeft"></path>
                                            <path d="M399 2L315 86" strokeWidth="10" stroke="url(#SvgjsLinearGradient1559)" strokeLinecap="round" className="TopRight"></path>
                                            <path d="M83 77L256 -96" strokeWidth="6" stroke="url(#SvgjsLinearGradient1559)" strokeLinecap="round" className="TopRight"></path>
                                            <path d="M281 212L460 33" strokeWidth="6" stroke="url(#SvgjsLinearGradient1559)" strokeLinecap="round" className="TopRight"></path>
                                            <path d="M257 62L76 243" strokeWidth="6" stroke="url(#SvgjsLinearGradient1559)" strokeLinecap="round" className="TopRight"></path>
                                            <path d="M305 123L214 214" strokeWidth="6" stroke="url(#SvgjsLinearGradient1558)" strokeLinecap="round" className="BottomLeft"></path>
                                            <path d="M327 222L440 109" strokeWidth="6" stroke="url(#SvgjsLinearGradient1558)" strokeLinecap="round" className="BottomLeft"></path>
                                            <path d="M287 109L362 34" strokeWidth="10" stroke="url(#SvgjsLinearGradient1559)" strokeLinecap="round" className="TopRight"></path>
                                            <path d="M259 194L332 121" strokeWidth="8" stroke="url(#SvgjsLinearGradient1559)" strokeLinecap="round" className="TopRight"></path>
                                            <path d="M376 186L240 322" strokeWidth="8" stroke="url(#SvgjsLinearGradient1559)" strokeLinecap="round" className="TopRight"></path>
                                            <path d="M308 153L123 338" strokeWidth="6" stroke="url(#SvgjsLinearGradient1559)" strokeLinecap="round" className="TopRight"></path>
                                            <path d="M218 62L285 -5" strokeWidth="8" stroke="url(#SvgjsLinearGradient1558)" strokeLinecap="round" className="BottomLeft"></path>
                                        </g>
                                        <defs>
                                            <mask id="SvgjsMask1551">
                                                <rect width="400" height="250" fill="#ffffff"></rect>
                                            </mask>
                                            <linearGradient x1="100%" y1="0%" x2="0%" y2="100%" id="SvgjsLinearGradient1558">
                                                <stop stopColor="rgba(var(--tb-white-rgb), 0)" offset="0"></stop>
                                                <stop stopColor="rgba(var(--tb-white-rgb), 0.1)" offset="1"></stop>
                                            </linearGradient>
                                            <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="SvgjsLinearGradient1559">
                                                <stop stopColor="rgba(var(--tb-white-rgb), 0)" offset="0"></stop>
                                                <stop stopColor="rgba(var(--tb-white-rgb), 0.1)" offset="1"></stop>
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </div>
                                <div className="card-body position-relative">
                                    <h5 className="card-title fw-medium">Add New Orders</h5>
                                    <p className="text-white-75">Orders are one of the main building blocks of creating an an ad campaign in Ad Manager.</p>
                                    <Link to="#!" className="link-light text-white">Create Order <i className="ph-arrow-right align-middle"></i></Link>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col xxl={9}>
                            <Card>
                                <div className="card-body">
                                    <div className="table-responsive table-card">
                                        <table className="table align-middle table-nowrap mb-0">
                                            <thead className="text-muted table-light">
                                                <tr>
                                                    <th scope="col">Product Name</th>
                                                    <th scope="col">MRP</th>
                                                    <th scope="col">Discount</th>
                                                    <th scope="col">Selling Price</th>
                                                    <th scope="col">size</th>
                                                    <th scope="col">color</th>
                                                    <th scope="col">Quantity</th>
                                                    <th scope="col" className="text-end">Total Amount</th>
                                                    <th scope="col" className="text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {orderinformation?.Cart?.CartItems?.length > 0 &&
                                                    orderinformation?.Cart?.CartItems?.map((item, index) => {
                                                        const orderStatusItem = orderStatus[index];
                                                        return (
                                                            <React.Fragment key={index}>
                                                                <tr>
                                                                    <td>
                                                                        <div className="d-flex align-items-center">
                                                                            <div className="flex-shrink-0 me-2">
                                                                                <img src={getImageURL(item?.ProductSizeColourCombination?.ProductColour?.id, item?.Product?.ProductImageColourCombinations)} className="avatar-xs rounded-circle" alt="Product" />
                                                                            </div>
                                                                            <Link to={`/ product - edit / ${item.productId}`} className="fw-medium link-primary">{item?.Product?.productTitle}</Link>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <span className="text-secondary">₹{item?.ProductSizeColourCombination?.MRP}</span>
                                                                    </td>
                                                                    <td>
                                                                        <span className="text-secondary">₹{item?.discount}</span>
                                                                    </td>
                                                                    <td>
                                                                        <span className="text-secondary">₹{item?.ProductSizeColourCombination?.sellingPrice}</span>
                                                                    </td>
                                                                    <td>{item?.ProductSizeColourCombination?.Size?.name}</td>
                                                                    <td><div style={{ height: "20px", width: "20px", borderRadius: "50%", border: "2px solid black", background: `${item?.ProductSizeColourCombination?.ProductColour?.hexCode} ` }}></div></td>
                                                                    <td>{item?.quantity} PCS</td>
                                                                    <td className="text-end">₹{item?.ProductSizeColourCombination?.sellingPrice * item?.quantity}</td>
                                                                    {orderStatusItem && (<td colSpan="7" className="text-center" key={`${index} -status`}>
                                                                        <Button
                                                                            variant="soft-info"
                                                                            size="sm"
                                                                            className="btn btn-sm mt-2 mt-sm-0"
                                                                            onClick={() => OrderStatusDetailsFunc(Object.keys(orderStatusItem)[0], item?.Product?.productTitle)}
                                                                        >
                                                                            Checking Status
                                                                        </Button>
                                                                    </td>

                                                                    )}
                                                                </tr>
                                                            </React.Fragment>
                                                        );
                                                    })
                                                }

                                                <tr>
                                                    <td colSpan={5}></td>
                                                    <td colSpan={4} className="p-0">
                                                        <table className="table table-borderless mb-0">
                                                            <tbody>
                                                                <tr>
                                                                    <td>Total MRP:</td>
                                                                    <td className="text-end">₹{orderinformation?.totalMRP}.00</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Discount on MRP:</td>
                                                                    <td className="text-end"><strong>-</strong> ₹{orderinformation?.totalMRPDiscount || 0}.00</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Coupon Discount:</td>
                                                                    <td className="text-end"><strong>-</strong>₹{orderinformation?.discount || 0}.00</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Delivery Fee:</td>
                                                                    <td className="text-end">₹<strike>{orderinformation?.shippingCharge}.00</strike> Free</td>

                                                                </tr>
                                                                <tr className="border-top">
                                                                    <th>Total Paid Amount :</th>
                                                                    <th className="text-end">₹{orderinformation?.totalAmount}.00</th>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                        <Col xxl={3}>
                            <Row>
                                <Col lg={12}>
                                    <Card>
                                        <div className="card-header d-flex align-items-center">
                                            <h5 className="card-title flex-grow-1 mb-0">Logistics Details</h5>
                                            <div className="flex-shrink-0">
                                                <Link to="#track-order" className="btn btn-sm btn-info">Track Order</Link>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="text-center">
                                                <i className="bi bi-truck fs-1"></i>
                                                <h5 className="fs-18">Toner Logistics</h5>
                                                <p className="mb-0">ID: MFDS1400457854</p>
                                                {/* <p className="mb-0">Payment Mode : {Payment?.paymentMethod}</p> */}
                                            </div>
                                        </div>
                                    </Card>
                                </Col>
                                <Col lg={12}>
                                    <Card>
                                        <div className="card-header">
                                            <h5 className="card-title mb-0">Payment Detail:</h5>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-sm table-borderless align-middle description-table mb-0">
                                                    <tbody>
                                                        {/* <tr>
                                                            <td>Transactions:</td>
                                                            <td><span className="fw-medium">{Payment?.paymentMethod == 'card' ? Payment?.transactionId : 'XXXX XXXX XXXX XXXX'}</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td>Card Number:</td>
                                                            <td><span className="fw-medium">XXXX XXXX XXXX</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td>Card Holder Name</td>
                                                            <td><span className="fw-medium">Dummy Name</span></td>
                                                        </tr> */}
                                                        <tr>
                                                            <td>Payment Method:</td>
                                                            <td><span className="fw-medium">COD</span></td>
                                                        </tr>
                                                        <tr>
                                                            <td>Total Amount:</td>
                                                            <td><span className="fw-medium">₹{orderinformation?.totalAmount}</span></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                        {OrderActivities?.length > 0 &&
                            <Col lg={12}>
                                <Card id="track-order">
                                    <div className="card-header d-flex  align-items-center gap-3">
                                        <h5 className="card-title flex-grow-1 mb-0">Order Status : {orderStatusDetails}</h5>
                                        <Dropdown >
                                            <Dropdown.Toggle variant='soft-primary' size="sm" id="dropdown-basic" className={`btn btn - sm mt - 2 mt - sm - 0 me - 1 ${isCancelled && "disabled"} `}

                                            ><i className="mdi mdi-archive-remove-outline align-bottom me-1"  ></i>
                                                Update Order
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item
                                                    value={"Order Process"}
                                                    disabled={isDisabled("Order Process", 0)}
                                                    onClick={() => handleOptionClick("Order Process", 0)}
                                                >
                                                    Order Process
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    value={"Packed"}
                                                    disabled={isDisabled("Packed", 1)}
                                                    onClick={() => handleOptionClick("Packed", 1)}
                                                >
                                                    Packed
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    value={"Order Shipped"}
                                                    disabled={isDisabled("Order Shipped", 2)}
                                                    onClick={() => handleOptionClick("Order Shipped", 2)}
                                                >
                                                    Order Shipped
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    value={"Out For Delivery"}
                                                    disabled={isDisabled("Out For Delivery", 3)}
                                                    onClick={() => handleOptionClick("Out For Delivery", 3)}
                                                >
                                                    Out For Delivery
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    value={"Delivered"}
                                                    disabled={isDisabled("Delivered", 4)}
                                                    onClick={() => handleOptionClick("Delivered", 4)}
                                                >
                                                    Delivered
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        <div className="flex-shrink-0">
                                            {/* <Button variant='soft-danger' size="sm" className={`btn btn - sm mt - 2 mt - sm - 0 ${isCancelled && "disabled"} `} ><i className="mdi mdi-archive-remove-outline align-bottom me-1"></i>Cancel Order</Button> */}
                                            {/* onClick={() => { OrderCancelFunc(DeleteID.id) }} */}
                                        </div>
                                    </div>



                                    <div className="card-body">
                                        <Row className="justify-content-between">
                                            {formatOrderActivities?.length > 0 &&
                                                formatOrderActivities?.map((item, index) => {
                                                    return (
                                                        <Col lg={2} className="order-tracking text-center completed" key={index}>
                                                            <span className="is-complete"></span>
                                                            <div className="card mt-3 mb-0">
                                                                <div className="card-body">
                                                                    <h6 className="fs-17">{item?.trackingStatus}</h6>
                                                                    <p className="text-muted fs-5 mb-0">{moment(item?.trackingTimeChange).format('llll')} </p>
                                                                    {!isCancelled && item?.trackingStatus != "Delivered" && item?.trackingStatus != "Order Process" && formatOrderActivities?.length == index + 1 &&
                                                                        <Button size="sm" className="btn btn-sm mt-2 mt-sm-0" variant='soft-danger' onClick={() => {
                                                                            setShowModal(!showModal)
                                                                            setDeleteID(item)
                                                                        }}> Remove Status</Button>}
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    )
                                                })
                                            }

                                            {cancelledOrders?.length > 0 && (
                                                <Col lg={2} className="order-tracking text-center completed">
                                                    <span className="is-complete"></span>
                                                    {cancelledOrders?.map((item, index) => (
                                                        <div key={index} className="card mt-3 mb-0">
                                                            <div className="card-body">
                                                                <h6 className="fs-17">{item?.trackingStatus}</h6>
                                                                <p className="text-muted fs-5 mb-0">{moment(item?.trackingTimeChange).format('llll')} </p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </Col>
                                            )}

                                            {cancelledOrders?.length == 0 ?
                                                Tracking?.slice(formatOrderActivities?.length)?.map((item, index) => {
                                                    return (
                                                        <Col lg={2} className="order-tracking text-center" key={index}>
                                                            <span className="is-complete"></span>
                                                            <div className="card mt-3 mb-0">
                                                                <div className="card-body">
                                                                    <h6 className="fs-17">{item}</h6>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    )
                                                }) :
                                                Tracking?.slice(formatOrderActivities?.length)?.map((item, index) => {
                                                    return (
                                                        null
                                                    )
                                                })
                                            }

                                        </Row>
                                    </div>

                                    {showModal && <DeleteModal showModal={showModal} setShowModal={setShowModal} data={DeleteID} handleSubmit={() => RemoveStatusFunc(DeleteID.id)} />}
                                </Card>
                            </Col>
                        }
                    </Row>
                    <Orderinvoicemodal responseinvoice={invoiceinfoData?.response} invoiceModalOpen={invoiceModalOpen} setInvoiceModalOpen={setInvoiceModalOpen} />
                </Container>
            </div>
        </React.Fragment >
    );
}

export default OrdersOverview;
